// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"ebec9948","436":"c0348ea5","453":"f394a27d","501":"209229e2","606":"eb693217","821":"13737a38","925":"5fd9219e","969":"6bb0072e"}[chunkId] + ".chunk.js";
};